import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDatasource, GridApi, GridOptions, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AgGridTenantUsersSettings } from './AgGridTenantUsersSettings';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';

@Component({
  selector: 'tenant-users',
  templateUrl: './tenant-users.component.html',
  styleUrls: ['./tenant-users.component.scss']
})
export class TenantUsersComponent implements OnInit {

  @Input('tenant') tenant!:TenantDto;
  rowData: UserDto[] = [];
  userData: UserDto[] = [];

  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridTenantUsersSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  constructor(private route: ActivatedRoute,
    public translate:TranslateService,
    private notificationService: NotificationService,
    private userProfileService: UserProfileService,
    private tenantService: TenantService) { }

  ngOnInit(): void {
    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridTenantUsersSettings(this.translate);
    this.frameworkComponents = {}
    this.gridOptions = this.aggridSettings.agGridTenantUsersSettings;

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'TenantUserProfile';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;
        this.tenantService.getUsersInTenancy(this.tenant.name,this.filter).subscribe({
          next: (users) => {
            let count = 0;
            this.userData = [];
            users.forEach((user: UserDto) => {
              //console.log("user confirmed = ", user.emailConfirmed)
              if (!user.emailConfirmed) {
                count++;
                user.userName = "(not confirmed)"; 
                this.userData.push(user);
                if (count == users.length) {
                  console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                  this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
                  //this.rowData = this.userData.sort();
                  //this.rowData = this.userData;
                  this.rowData = this.rowData.slice(params.startRow, params.endRow);
                  let lastRow = -1;
  
                  if (users.length <= params.endRow) {
                    lastRow = users.length;
                  }
                  params.successCallback(this.rowData, lastRow);
                  this.isLoadingResults = false;
                  this.isRateLimitReached = false;
                  this.resultsLength = this.rowData.length;
  
                  this.gridApi.hideOverlay();
                }
              } else {
                // mit Id Identity User lesen und aktuelle Daten (firstName, lastName, phonenumber) in den tenant user schreiben
                this.userProfileService.getUserById(user.id).subscribe({
                  next:(userProfile: UserProfileForCreation) => {       
                    count++;
                    user.userName = userProfile.fullName;
                    user.firstName = userProfile.givenName;
                    user.lastName = userProfile.familyName;
                    user.phoneNumber = userProfile.phoneNumber;
                    this.userData.push(user);
                    console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                    if (count == users.length) {
                      console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                      this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
                      //this.rowData = this.userData.sort();
                      //this.rowData = this.userData;
                      this.rowData = this.rowData.slice(params.startRow, params.endRow);
                      let lastRow = -1;
      
                      if (users.length <= params.endRow) {
                        lastRow = users.length;
                      }
                      params.successCallback(this.rowData, lastRow);
                      this.isLoadingResults = false;
                      this.isRateLimitReached = false;
                      this.resultsLength = this.rowData.length;
      
                      this.gridApi.hideOverlay();
                    }
                  }
                });           
              }
            });
          },
          error: (error: any) => {
            this.isLoadingResults = false;
            this.isRateLimitReached = true;
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
          }
        })
      }
    }
  }

  onGridReady(params: any) {
    this.gridApi = params.api;    
    this.gridApi.sizeColumnsToFit();    
    this.gridApi.setDatasource(this.ds)
  }
}
